/* eslint-disable */

import React, { Component, Fragment } from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import Divider from '@material-ui/core/Divider'
import gql from 'graphql-tag'
import { Query, withApollo, Subscription } from 'react-apollo'
import { Typography, Grid } from '@material-ui/core'
import axios from 'axios'
import withRouter from 'react-router-dom/withRouter'
import MUIDataTable from 'mui-datatables'
import getLoginId from '../../../utils/getLoginId'
import FileSaver from 'file-saver'
const GET_MODELS = gql`
  query {
    models: allDeviceModels(status: 1) {
      id
      model_name
    }
  }
`
const GET_FILE_FORMAT = gql`
  query getPublicDownloadURL($bucketname: String!, $filename: String!) {
    getPublicDownloadURL(bucketName: $bucketname, filename: $filename)
  }
`
const GET_MANUFACTURER = gql`
  query {
    manufacturers: getAllManufacturer(status: 1) {
      id
      manufacturerName
      manufacturerCode
    }
  }
`

const DEASSIGN_DEVICE = gql`
  mutation excelFileUpload(
    $fileInfo: FileUploadInput!
    $commonInput: CommonInput!
  ) {
    excelFileUpload(fileInfo: $fileInfo, commonInput: $commonInput) {
      failedToUpload
      totalExcelDataRecords
      totalDuplicateRecords
      successfullyUploaded
      failedUploadList
    }
  }
`

const GET_UPLOAD_URL = gql`
  mutation($fileExtension: String!) {
    getPublicUploadURL(fileExtension: $fileExtension) {
      bucketName
      filename
      publicUploadURL
    }
  }
`
const styles = theme => ({
  button: {
    display: 'block',
    marginTop: theme.spacing.unit * 2
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit * 2
  }
})

class DeassignDevices extends Component {
  state = {
    open: false,
    open1: false,
    modelname: '',
    isModelNameValid: false,
    isManufacturerNameValid: false,
    manufacturerName: '',
    open_man: false,
    manufacturerCode: '',
    manufacturerId: '',
    publicUploadURL: '',
    fileName: '',
    bucketName: '',
    isUploading: false,
    uploadSucess: true,
    response: '',
    failList: '',
    result: false,
    isLoading: false,
    disable: false
  }
  columns = ['Serial Number', 'IMEI Number', 'Reason']

  options = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 15

    // sort: false,
    // filter: false,
    //  search: false,
    // print: false,
    // download: false
    // viewColumns: false,
    // pagination: false
  }
  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
  }

  setToDefaults = () => {
    this.setState({
      response: '',
      failList: '',
      result: false,
      isLoading: false,
      publicUploadURL: '',
      fileName: '',
      bucketName: '',
      disable: false
    })
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  handleOpenSelect = () => {
    this.setState({ open1: true })
  }
  handleCloseSelect = () => {
    this.setState({ open1: false })
  }
  handleOpenSelectMan = () => {
    this.setState({ open_man: true })
  }
  handleCloseSelectMan = () => {
    this.setState({ open_man: false })
  }

  checkModelNameValidity = () => {
    this.setState({
      isModelNameValid: this.state.modelname !== ''
    })
  }
  // checkManufacturerNameValidity = () => {
  //   console.log(this.state.manufacturerName)
  //   const code = this.state.manufacturerName.split('*')
  //   console.log('man', code[0])
  //   this.setState({
  //     isManufacturerNameValid: this.state.manufacturerName !== '',
  //     // manufacturerCode:this
  //     uniqueSerialNumber: code[1] + '_' + this.state.serialno,
  //     manufacturerId: code[0]
  //   })
  // }

  downloadBulkDeassign = client => async event => {
    console.log('click fun')
    const { data } = await this.props.client.query({
      query: GET_FILE_FORMAT,
      variables: {
        bucketname: 'excel-templates',
        filename: 'deAssignDeviceTemplate.xlsx'
      },
      errorPolicy: 'all'
    })
    console.log('file', data.getPublicDownloadURL)
    const res = await axios({
      url: data.getPublicDownloadURL,
      method: 'GET',
      headers: { Accept: 'application/vnd.ms-excel' },
      responseType: 'blob' // important
    })
    FileSaver.saveAs(new Blob([res.data]), 'sample.xlsx')
    // FileSaver.saveAs(data.getPublicDownloadURL, 'sample.xlsx')
  }

  // handleSubmit = addDevice => e => {
  handleSubmit = client => async event => {
    event.preventDefault()
    this.setState({ isLoading: true, disable: true })
    let manarr = this.state.manufacturerName.split('*')
    // console.log(
    //   'click fun',
    //   this.state.bucketName,
    //   this.state.fileName,
    //   manarr[0],
    //   manarr[1],
    //   this.state.modelname
    // )
    const { data, errors } = await client.mutate({
      mutation: DEASSIGN_DEVICE,
      variables: {
        fileInfo: {
          uploadFor: 'deAssignDeviceFromSubscription',
          bucketName: this.state.bucketName,
          fileName: this.state.fileName,
          operationType: 'SKIP'
        },
        commonInput: {
          clientLoginId: parseInt(this.props.match.params.loginId, 10),
          subscriptionId: parseInt(this.props.match.params.subscriptionId, 10)
        }
      },
      errorPolicy: 'all'
    })

    this.setState({ isLoading: false })
    if (data !== null) {
      console.log('data files', data)
      let fullData = []
      let arrList = data.excelFileUpload.failedUploadList
      console.log('arr_list', JSON.parse(arrList))
      JSON.parse(arrList).forEach(element => {
        var rowData = []
        // this.clientId.push(element.id)
        rowData.push(element.serialNum)
        rowData.push(element.imeiNum)
        rowData.push(element.errorMsg)
        // console.log('rowdata', toString(element.serialNumber))
        fullData.push(rowData)
      })
      // this.state.simprovider = ''
      this.setState({
        response:
          'Total Excel Records= ' +
          data.excelFileUpload.totalExcelDataRecords +
          ',' +
          'Total Records Uploaded=' +
          data.excelFileUpload.successfullyUploaded +
          ', Total Records Failed To Upload=' +
          data.excelFileUpload.failedToUpload +
          ', Total Duplicate Records in Excel=' +
          data.excelFileUpload.totalDuplicateRecords,
        uploadSucess: true,
        failList: fullData,
        result: true
      })
    } else {
      this.setState({ response: errors[0].message, uploadSucess: true })
    }

    console.log('res=', this.state.failList)
  }

  onUpload = async ({
    target: {
      validity,
      files: [file]
    }
  }) => {
    // TODO: Handle upload errors
    this.setState({ isUploading: true })
    if (validity.valid) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)

      const response = await this.props.client.mutate({
        mutation: GET_UPLOAD_URL,
        variables: {
          fileExtension
        }
      })
      // console.log('response', response)
      if (response.data && response.data.getPublicUploadURL) {
        const url = response.data.getPublicUploadURL.publicUploadURL
        await axios.put(url, file, {
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": file.type || "application/octet-stream"
          }
        })
        // console.log('upload', res)
        this.setState({
          fileName: response.data.getPublicUploadURL.filename,
          bucketName: response.data.getPublicUploadURL.bucketName,
          publicUploadURL: response.data.getPublicUploadURL.publicUploadURL
        })
      }
    }
    this.setState({ isUploading: false })
  }
  render() {
    const { classes } = this.props
    // console.log('clients', this.props.match.params.subscriptionId)

    return (
      <div className={classes.root}>
        <Grid container direction="row" justify="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography variant="title"> Deassign Device Bulk</Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={12} sm="6">
              {' '}
              Download sample template for device deassign bulk
            </Grid>
            <Grid item xs={12} sm="6">
              <Button
                color="secondary"
                variant="contained"
                className={classes.button}
                onClick={this.downloadBulkDeassign(this.props.client)}
              >
                Download Excel
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {this.state.uploadSucess && (
              <Typography variant="subheading" color="primary">
                {this.state.response}
              </Typography>
            )}
          </Grid>
          <Divider light />
          <form style={{ minWidth: '40%' }}>
            <Grid item xs={12}>
              <Fragment>
                <input
                  accept="*/*"
                  id="contained-button-file"
                  multiple
                  type="file"
                  style={{
                    display: 'none'
                  }}
                  onChange={this.onUpload}
                />
                <label htmlFor="contained-button-file">
                  Upload excel file here &nbsp;
                  <Button variant="contained" component="span" color="primary">
                    {this.state.isUploading ? (
                      <CircularProgress size={15} />
                    ) : (
                      'Upload'
                    )}
                  </Button>
                </label>
              </Fragment>
            </Grid>
            <br />
            <br />
            <Grid item xs={12}>
              <Button
                color="default"
                variant="contained"
                onClick={this.setToDefaults}
              >
                SET TO DEFAULTS
              </Button>
              {'       '}
              {'       '}
              <Button
                color="default"
                variant="contained"
                onClick={() => this.props.history.goBack()}
              >
                Cancel
              </Button>
              {'       '}
              {'       '}
              <Button
                onClick={this.handleSubmit(this.props.client)}
                type="submit"
                color="primary"
                variant="contained"
                disabled={!this.state.fileName || this.state.disable}
              >
                Submit
              </Button>{' '}
              {this.state.isLoading && (
                <h3>Excel sheet upload is in progress..</h3>
              )}
            </Grid>
            {this.state.result && (
              <Grid item xs={12}>
                {/* TODO: Replace this with a custom table going forward */}
                <h5>Failed records list</h5>
                <MUIDataTable
                  data={this.state.failList}
                  columns={this.columns}
                  options={this.options}
                />
              </Grid>
            )}
          </form>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(withRouter(withApollo(DeassignDevices)))



// WEBPACK FOOTER //
// ./src/components/Pages/DeassignDevice/DeassignInventory.jsx